module.exports = __webpack_public_path__ + "aa4b8df6a8ead7525b460a8292962ba5.svg";